/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: tGgk6oqzsXGR
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebTopNav.module.css"; // plasmic-import: tGgk6oqzsXGR/css

createPlasmicElementProxy;

export const PlasmicWebTopNav__VariantProps = new Array();

export const PlasmicWebTopNav__ArgProps = new Array("pageTitle", "pageButtons");

const $$ = {};

function PlasmicWebTopNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"webTopNav"}
      data-plasmic-override={overrides.webTopNav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.webTopNav
      )}
    >
      <div
        data-plasmic-name={"pageTitleSlot"}
        data-plasmic-override={overrides.pageTitleSlot}
        className={classNames(projectcss.all, sty.pageTitleSlot)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.pageTitle
        })}
      </div>
      <div
        data-plasmic-name={"topnavButtonsSlot"}
        data-plasmic-override={overrides.topnavButtonsSlot}
        className={classNames(projectcss.all, sty.topnavButtonsSlot)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.pageButtons
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  webTopNav: ["webTopNav", "pageTitleSlot", "topnavButtonsSlot"],
  pageTitleSlot: ["pageTitleSlot"],
  topnavButtonsSlot: ["topnavButtonsSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebTopNav__ArgProps,
          internalVariantPropNames: PlasmicWebTopNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebTopNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "webTopNav") {
    func.displayName = "PlasmicWebTopNav";
  } else {
    func.displayName = `PlasmicWebTopNav.${nodeName}`;
  }
  return func;
}

export const PlasmicWebTopNav = Object.assign(
  // Top-level PlasmicWebTopNav renders the root element
  makeNodeComponent("webTopNav"),
  {
    // Helper components rendering sub-elements
    pageTitleSlot: makeNodeComponent("pageTitleSlot"),
    topnavButtonsSlot: makeNodeComponent("topnavButtonsSlot"),
    // Metadata about props expected for PlasmicWebTopNav
    internalVariantProps: PlasmicWebTopNav__VariantProps,
    internalArgProps: PlasmicWebTopNav__ArgProps
  }
);

export default PlasmicWebTopNav;
/* prettier-ignore-end */
